import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ScreenLoader from "../../../components/ScreenLoader";

const SMBookMarketTable = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div className="card shadow mb-4">
      <div className="table-responsive">
        <table className="table table-bordered dataTable" width="100%">
          <thead>
            <tr className="bg-gray-300">
              <th>S.No.</th>
              <th>Market Id</th>
              <th>Market Name</th>
              <th>Start Date</th>
              <th>Result</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data.map((game, index) => (
                <tr key={game.MarketId} className={index % 2 === 0 ? "even" : "odd"}>
                  <td>{index + 1}</td>
                  <td>{game.MarketId}</td>
                  <td>{game.MarketName}</td>
                  <td>{game.CreatedOn}</td>
                  <td>{game.Result == '' ? 'Running' : game.Result}</td>
                  <td>
                    <button
                      className="custom-grey-btn"
                      onClick={() => navigate(`/matka-booked-bet/${game.MarketId}/${game.MarketName}`)}
                    >
                      Booked
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SMBookMarketTable;
